import parseValue from "@/react/validation/parseValue";

const VALIDATION_REGEX = /^\d{2}\.\d{2}\.\d{2}$/;
const EXTRACTION_REGEX =
  /^(?<hours>\d{2})\.(?<minutes>\d{2})\.(?<seconds>\d{2})$/;
const INVALID_RESULT = { isValid: false };

/**
 * Extract Oxygen-compatible duration data object from a string using the
 * "hh.mm.ss" format. If the string does not properly represent the format then,
 * return { isValid: false }.
 *
 * @param rawValue
 * @return {{isValid: boolean}|{isValid: boolean, durationData: {hours: number, minutes: number, seconds: number}}}
 */
const extractDurationData = (rawValue) => {
  const parsedValue = (rawValue?.toString() ?? "").trim();
  if (!VALIDATION_REGEX.test(parsedValue)) {
    return INVALID_RESULT;
  }

  const match = EXTRACTION_REGEX.exec(parsedValue);
  const hours = parseValue(match.groups?.hours);
  const minutes = parseValue(match.groups?.minutes);
  const seconds = parseValue(match.groups?.seconds);

  if (hours > 23 || minutes > 59 || seconds > 59) {
    return INVALID_RESULT;
  }

  return {
    isValid: true,
    durationData: { hours, minutes, seconds },
  };
};

export default extractDurationData;
